import { RouteConfig } from "vue-router";
import { UserState } from "@/store/modules/auth/interfaces";

export const settings_routes: RouteConfig = {
  path: "/settings",
  component: () => import("@/views/settings/SettingsWrapper.vue"),
  meta: {
    user_state: [
      UserState.CANDIDATE,
      UserState.RECRUITER,
      UserState.RECRUITER_ADMIN,
      UserState.CANDIDATE_PROFILE_PENDING
    ]
  },
  children: [
    {
      path: "",
      redirect: {
        name: "accounts-setting"
      }
    },
    {
      path: "account",
      name: "accounts-setting",
      component: () => import("@/views/settings/Account.vue"),
      meta: {
        name: "nav-sidebar.settings",
        icon: require("@/assets/icons/nav_sidebar/active/settings.svg"),
        user_state: [
          UserState.CANDIDATE,
          UserState.RECRUITER,
          UserState.RECRUITER_ADMIN,
          UserState.CANDIDATE_PROFILE_PENDING
        ]
      }
    },
    {
      path: "company",
      component: () => import("@/views/company/CompanyProfileIndex.vue"),
      meta: {
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      },
      children: [
        {
          path: "",
          redirect: {
            name: "company-profile"
          }
        },

        {
          path: "profile",
          name: "company-profile",
          component: () => import("@/views/company/CompanyProfile.vue"),
          meta: {
            name: "nav-sidebar.settings",
            icon: require("@/assets/icons/nav_sidebar/active/settings.svg"),
            user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
          }
        },
        {
          path: "edit",
          name: "edit-company-profile",
          component: () => import("@/views/company/EditCompanyDetails.vue"),
          meta: {
            name: "nav-sidebar.settings",
            icon: require("@/assets/icons/nav_sidebar/active/settings.svg"),
            user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
          }
        }
      ]
    },
    {
      path: "*",
      component: () => import("../views/NotFound.vue"),
      meta: {
        name: "nav-sidebar.not-found",
        icon: require("@/assets/icons/nav_sidebar/active/settings.svg"),
        user_state: [
          UserState.UNAUTHENTICATED,
          UserState.EMAIL_VERIFICATION_PENDING,
          UserState.EMAIL_VERIFICATION_COMPLETED,
          UserState.ONBOARDING_PENDING,
          UserState.RECRUITER,
          UserState.RECRUITER_ADMIN,
          UserState.CANDIDATE
        ]
      }
    }
  ]
};
